import React from 'react'

function TermsOfService() {
  return (
    <div id="terms" className="basic-1">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h1 className="blue text-center">Terms of Service</h1>
            <p className="text-center"><em>Last updated: June 15, 2025</em></p>
            
            <div className="text-container">
              <h3>1. Acceptance of Terms</h3>
              <p>
                By accessing and using FalconEye AI Solutions' website and services, you accept and agree to be bound by the terms and provision of this agreement. 
                If you do not agree to abide by the above, please do not use this service.
              </p>

              <h3>2. Description of Service</h3>
              <p>
                FalconEye AI Solutions provides artificial intelligence, autonomous agents, Model Context Protocol (MCP) integration, and blockchain technology solutions 
                for business productivity enhancement. Our services include but are not limited to:
              </p>
              <ul>
                <li>AI-powered business intelligence and analytics</li>
                <li>Autonomous AI agent development and deployment</li>
                <li>Model Context Protocol integration services</li>
                <li>Blockchain-secured operations and smart contract development</li>
                <li>Consulting and implementation services</li>
                <li>Ongoing support and optimization</li>
              </ul>

              <h3>3. User Obligations</h3>
              <p>As a user of our services, you agree to:</p>
              <ul>
                <li>Provide accurate and complete information when requested</li>
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Use our services only for lawful purposes</li>
                <li>Not attempt to gain unauthorized access to our systems</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Respect intellectual property rights</li>
              </ul>

              <h3>4. Intellectual Property Rights</h3>
              <p>
                All content, features, and functionality of our services, including but not limited to text, graphics, logos, icons, images, audio clips, 
                digital downloads, data compilations, software, and AI models, are the exclusive property of FalconEye AI Solutions and are protected by 
                copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>

              <h3>5. Data Security and Confidentiality</h3>
              <p>
                We implement enterprise-grade security measures to protect your data, including:
              </p>
              <ul>
                <li>End-to-end encryption for all data transmissions</li>
                <li>Secure data storage with regular backups</li>
                <li>Access controls and authentication protocols</li>
                <li>Regular security audits and compliance monitoring</li>
                <li>Blockchain-based audit trails for transparency</li>
              </ul>

              <h3>6. Service Availability</h3>
              <p>
                While we strive to maintain 99.9% uptime, we do not guarantee uninterrupted access to our services. Scheduled maintenance, 
                updates, and unforeseen technical issues may temporarily affect service availability. We will provide advance notice of 
                planned maintenance whenever possible.
              </p>

              <h3>7. Limitation of Liability</h3>
              <p>
                FalconEye AI Solutions shall not be liable for any indirect, incidental, special, consequential, or punitive damages, 
                including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use 
                of our services, even if we have been advised of the possibility of such damages.
              </p>

              <h3>8. AI and Automation Disclaimer</h3>
              <p>
                Our AI systems and autonomous agents are designed to assist and enhance human decision-making, not replace human judgment. 
                Users are responsible for:
              </p>
              <ul>
                <li>Reviewing and validating AI-generated recommendations</li>
                <li>Ensuring compliance with industry-specific regulations</li>
                <li>Maintaining appropriate human oversight of automated processes</li>
                <li>Understanding the limitations of AI technology</li>
              </ul>

              <h3>9. Subscription and Payment Terms</h3>
              <p>
                Subscription fees are billed in advance on a monthly or annual basis. All fees are non-refundable except as required by law. 
                We reserve the right to modify pricing with 30 days advance notice to existing customers.
              </p>

              <h3>10. Termination</h3>
              <p>
                Either party may terminate this agreement at any time with written notice. Upon termination, your access to our services will cease, 
                and we will provide you with your data in a standard format within 30 days of termination request.
              </p>

              <h3>11. Governing Law</h3>
              <p>
                These terms shall be governed by and construed in accordance with the laws of the jurisdiction in which FalconEye AI Solutions 
                is incorporated, without regard to its conflict of law provisions.
              </p>

              <h3>12. Changes to Terms</h3>
              <p>
                We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through 
                our service interface. Continued use of our services after such modifications constitutes acceptance of the updated terms.
              </p>

              <h3>13. Contact Information</h3>
              <p>
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <ul>
                <li>Email: legal@falconeye.io</li>
                <li>Address: FalconEye AI Solutions Legal Department</li>
                <li>Phone: Available through our support portal</li>
              </ul>

              <div className="text-center" style={{marginTop: '40px'}}>
                <a className="btn-solid-reg" href="#contact">Contact Legal Team</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsOfService

